import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { FileText, File } from "react-feather";
import { C } from "../reporting/reportingStyles";
import { Loader } from "../reporting/ReportingShared";
import { getPageTemplates } from "../../utils/merchantPagesApi";
import { hintStyle } from "./pageStyles";

const cardStyle = {
  textAlign: "left",
  border: `1px solid ${C.border}`,
  borderRadius: 12,
  padding: 16,
  background: C.white,
  cursor: "pointer",
  display: "flex",
  gap: 12,
  alignItems: "flex-start",
  width: "100%",
};

/** "New page → start from…". Picking a template copies it into the editor; nothing is saved yet. */
const TemplatePickerModal = ({ isOpen, onPick, onClose }) => {
  const [templates, setTemplates] = useState(null);

  useEffect(() => {
    if (!isOpen || templates) return;
    getPageTemplates().then(setTemplates);
  }, [isOpen, templates]);

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg">
      <ModalHeader toggle={onClose}>Start a new page</ModalHeader>
      <ModalBody>
        {!templates ? <Loader /> : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 12 }}>
            {templates.map((t) => (
              <button key={t.id} type="button" style={cardStyle} onClick={() => onPick(t)}>
                <FileText size={22} color={C.coral} style={{ flexShrink: 0 }} />
                <span>
                  <strong style={{ display: "block", color: C.text, fontSize: 14 }}>{t.name}</strong>
                  <span style={{ display: "block", color: C.textMed, fontSize: 12, marginTop: 2 }}>{t.description}</span>
                  <span style={{ display: "block", color: C.textLight, fontSize: 11, marginTop: 6 }}>
                    {t.sections?.blocks?.length || 0} sections · /{t.defaultSlug}
                  </span>
                </span>
              </button>
            ))}
            <button type="button" style={cardStyle} onClick={() => onPick(null)}>
              <File size={22} color={C.textLight} style={{ flexShrink: 0 }} />
              <span>
                <strong style={{ display: "block", color: C.text, fontSize: 14 }}>Blank page</strong>
                <span style={{ display: "block", color: C.textMed, fontSize: 12, marginTop: 2 }}>Start with no sections.</span>
              </span>
            </button>
          </div>
        )}
        <div style={{ ...hintStyle, marginTop: 14 }}>
          Templates are a generic starting point written for the Wags ordering apps. Review every clause with the merchant before publishing — they are not legal advice.
        </div>
      </ModalBody>
    </Modal>
  );
};

export default TemplatePickerModal;
